import Cookies from 'js-cookie';
import {base_url} from '../config';
import _axios from 'axios';
import logger from '../utils/logger';
const {nError, NProgress, localStorage} = window;
class Axios {
  constructor() {
    this.currentToken = null;
    this.service = _axios.create({
      baseURL: base_url,
    });
    this.service.interceptors.request.use(
      (config) => {
        NProgress.start();
        config.headers.Authorization = `Bearer ${this._getJWT()}`;
        return config;
      },
      (error) => {
        NProgress.done();
        return Promise.reject(error);
      },
    );
    this.service.interceptors.response.use(
      (response) => {
        NProgress.done();
        return response;
      },
      (error) => {
        NProgress.done();
        return Promise.reject(error);
      },
    );
  }

  async post(url, payload, options = {}) {
    try {
      logger.log("Doing something", url, payload);

      const {data} = await this.service.post(url, payload);
      return data;
    } catch (error) {
      return this._handleErrors(error, options);
    }
  }

  async put(url, payload, options = {}) {
    logger.log(url, payload)
    try {
      const {data} = await this.service.put(url, payload);
      return data;
    } catch (error) {
      return this._handleErrors(error, options);
    }
  }

  async saveBot(chatbotId, payload, options = {}) {
    try {
      logger.log("Save BOT")
      const {data} = await this.service.post(`chatbot/saveBot/${chatbotId}`, payload);
      return data;
    } catch (error) {
      return this._handleErrors(error, options);
    }
  }


  async get(url, payload, options = {}) {
    try {
      const {data} = await this.service.get(url, payload);
      return data;
    } catch (error) {
      return this._handleErrors(error, options);
    }
  }

  async postCrmLoginRequestCode(payload) {
    try {
      const {data} = await this.service.post('/crm-login/request-code', payload);
      return data;
    } catch (error) {
      return this._handleErrors(error);
    }
  }

  async postCrmLoginVerifyCode(payload) {
    try {
      const {data} = await this.service.post('/crm-login/verify-code', payload);
      return data;
    } catch (error) {
      return this._handleErrors(error);
    }
  }

  async delete(url, payload, options = {}) {
    logger.log(url, payload)
    try {
      //Used here const {data} = await this.service.delete(url, payload); so would delete invoice, and projects? but did not delete blocks anymore..
      const {data} = await this.service.delete(url, {data: payload});
      return data;
    } catch (error) {
      return this._handleErrors(error, options);
    }
  }

  async patch(url, payload, options = {}) {
    try {
      const { data } = await this.service.patch(url, payload);
      return data;
    } catch (error) {
      return this._handleErrors(error, options);
    }
  }

  _handleErrors(error, options = {}) {
    const {status} = error.response;
    const {silent = false} = options;
    
    switch (status) {
      case 400: {
        // Bad Request - return error data without showing notification
        // The calling code will handle displaying appropriate messages
        return {
          status,
          ...error.response?.data,
        };
      }
      case 422: {
        return {
          status,
          ...error.response?.data,
        };
      }
      case 404: {
        return {
          status,
          message: error.message,
          ...error.response?.data,
        };
      }
      case 409: {
        return {
          status,
          ...error.response?.data,
        };
      }
      case 403: {
        return {
          status,
          ...error.response?.data,
        };
      }
      case 401: {
        // Only show error notification if not in silent mode
        if (!silent) {
          nError({
            title: 'Unauthorized',
            text: 'Your session has been expired, Please login again',
            icon: 'fa-exclamation-triangle',
          });
        }
        return {
          status,
          ...error.response?.data,
        };
      }
      default: {
        if (!silent) {
          nError({title: 'Critical Error', text: error, icon: 'fa-exclamation-triangle'});
        }
        return {
          status,
          ...error.response?.data,
        };
      }
    }
  }

  _getJWT() {
    if (localStorage) {
      // First check cookie (newest token)
      const cookieJwt = Cookies.get('sid');
      if (cookieJwt) {
        // Store in localStorage and remove from cookie
        localStorage.setItem('sid', cookieJwt);
        Cookies.remove('sid');
        this._onTokenChange(cookieJwt);
        return cookieJwt;
      }
      
      // Then check localStorage (fallback)
      const localStorageJwt = localStorage.getItem('sid');
      if (localStorageJwt) {
        this._onTokenChange(localStorageJwt);
        return localStorageJwt;
      }
    }
    return null;
  }

  _onTokenChange(newToken) {
    if (newToken !== this.currentToken) {
      this.currentToken = newToken;
      // If token changed and we had a previous token, clear user state
      if (this.currentToken && newToken !== this.currentToken) {
        // Import and clear user state to force refresh
        try {
          const { User } = require('../states/actions');
          User.clear();
        } catch (error) {
          logger.log('User actions not available yet');
        }
      }
    }
  }

  // Add method to clear JWT token
  clearJWT() {
    if (localStorage) {
      localStorage.removeItem('sid');
    }
    Cookies.remove('sid');
  }
}
export const axios = new Axios();
